import React from 'react';
import { BiCopy, BiTrash, BiDotsVerticalRounded, BiMoveHorizontal } from 'react-icons/bi';
import { Button } from '../ui';
import { getFieldTypeMeta } from '../../features/builder/fieldRegistry';
import FieldPreview from './field-types/FieldPreview';

const QuestionCard = ({
  field,
  index,
  isSelected,
  onSelect,
  onDuplicate,
  onDelete,
  onCopy,
  onMove,
  dragHandleProps,
}) => {
  const meta = getFieldTypeMeta(field.type);
  const Icon = meta.icon;

  return (
    <div
      role="listitem"
      data-field-id={field.id}
      className={`builder-question-card ${isSelected ? 'builder-question-card--selected' : ''}`}
      onClick={() => onSelect(field)}
      onKeyDown={(e) => e.key === 'Enter' && onSelect(field)}
      tabIndex={0}
    >
      {dragHandleProps && (
        <span className="builder-question-card__drag" {...dragHandleProps} aria-label="Drag to reorder">⋮⋮</span>
      )}
      <div className="builder-question-card__header">
        <span className="builder-question-card__number">{index + 1}</span>
        <div className="builder-question-card__title-wrap">
          <div className="builder-question-card__title">
            {field.name || 'Untitled question'}
            {!field.optional && <span className="builder-question-card__required" aria-label="Required">*</span>}
          </div>
          <span className="builder-question-card__badge">
            <Icon aria-hidden="true" /> {meta.label}
          </span>
        </div>
        <div className="builder-question-card__actions">
          {field.id && onMove && (
            <Button
              variant="ghost"
              size="sm"
              icon={<BiMoveHorizontal />}
              aria-label="Move to section"
              title="Move to"
              onClick={(e) => { e.stopPropagation(); onMove(field); }}
            />
          )}
          {/* <Button variant="ghost" size="sm" icon={<BiCopy />} aria-label="Duplicate" onClick={(e) => { e.stopPropagation(); onDuplicate?.(field); }} /> */}
          <Button variant="ghost" size="sm" icon={<BiTrash />} aria-label="Delete" onClick={(e) => { e.stopPropagation(); onDelete?.(field); }} />
        </div>
      </div>
      <FieldPreview field={field} />
    </div>
  );
};

export default QuestionCard;
